import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Linkify from "linkify-react";
import { useState } from "react";

const StringDisplay = ({
  text,
  previewChars = 50,
}: {
  text: string;
  previewChars?: number;
}) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <p onClick={handleClickOpen} style={{ cursor: "pointer" }}>
        {text.length > previewChars ? text.slice(0, previewChars) + " ... " : text}
      </p>
      <Dialog open={open} onClose={handleClose}>
        <DialogContent
          sx={{
            padding: 2,
            maxWidth: "50rem",
            wordWrap: "break-word",
            lineHeight: 1.6,
            fontSize: "1rem",
          }}
        >
          <Linkify options={{ target: "about" }}>{text}</Linkify>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default StringDisplay;
